<template>
  <div
    class="custom-recharge-page"
    :class="{
      'has-dock-promo':
        page.floatAd === 1 &&
        page.enableAd === 1 &&
        adList.length &&
        !adClosed
    }"
  >
    <div v-if="bootLoading" class="page-boot">加载中…</div>

    <template v-else-if="bootError">
      <div class="page-boot page-boot--err">{{ bootError }}</div>
    </template>

    <template v-else>
      <div
        :class="[
          'recharge',
          'custom-recharge-layer',
          { 'custom-recharge-layer--banner': !!page.bannerImage }
        ]"
        :style="bannerLayerStyle"
      >
        <div class="wrap">
          <div class="form">
            <div class="form-content">
              <van-form ref="form" @submit="subSuccess">
                <ul class="form-ul">
                  <li>
                    <van-field
                      v-model="form.code"
                      :placeholder="fieldCopy.code.placeholder"
                      :rules="rules.code"
                      :maxlength="16"
                      :label="fieldCopy.code.label"
                      @blur="redeemChange"
                    />
                  </li>
                  <li>
                    <van-field
                      ref="focusinput"
                      v-model="form.phone"
                      :placeholder="fieldCopy.account.placeholder"
                      :rules="rules.phone"
                      :label="fieldCopy.account.label"
                      :type="useSmsCaptcha ? 'tel' : 'text'"
                      :maxlength="useSmsCaptcha ? '11' : 'max'"
                    />
                  </li>
                  <li class="tow-para">
                    <van-field
                      v-model="form.captcha"
                      :placeholder="fieldCopy.captcha.placeholder"
                      :rules="rules.captcha"
                      :label="fieldCopy.captcha.label"
                      :maxlength="useSmsCaptcha ? 6 : 5"
                    />
                    <div
                      v-if="useSmsCaptcha"
                      :class="subBtnDisable ? 'smsCode is-disable' : 'smsCode'"
                    >
                      <div v-if="!time" class="subtnCode" @click="getSmsCode">
                        获取验证码
                      </div>
                      <van-count-down
                        v-else
                        class="cdown"
                        :time="time"
                        format="ss 秒"
                        @finish="time = 0"
                      />
                    </div>
                    <div v-else class="btn btn-img" @click="getImgCode">
                      <img :src="captchaImg.captchaBase64" alt="" />
                    </div>
                  </li>
                </ul>
              </van-form>
            </div>
            <div
              :class="subBtnDisable ? 'btn-sub is-disable' : 'btn-sub'"
              @click="submit"
            >
              立即兑换
            </div>
          </div>

          <div class="rule">
            <h2><span>兑换规则</span></h2>
            <div
              v-if="page.exchangeRules"
              class="rule-html"
              v-html="page.exchangeRules"
            />
            <div v-else class="rule-empty">暂无规则说明</div>
          </div>

          <a class="beian" href="https://beian.miit.gov.cn/"
            >闽ICP备14019793号-8</a
          >
        </div>

        <div
          v-if="page.enableAd === 1 && adList.length && !adClosed"
          class="promo-strip"
          :class="{ 'promo-strip--dock': page.floatAd === 1 }"
        >
          <button
            type="button"
            class="promo-strip__close"
            aria-label="关闭"
            @click.stop="closeAd"
          >
            <img
              class="promo-strip__close-icon"
              :src="closeGrayImg"
              alt=""
            />
          </button>
          <van-swipe :autoplay="4000" indicator-color="#4086FF">
            <van-swipe-item v-for="(ad, i) in adList" :key="i">
              <div class="promo-strip__slide" @click="onAdClick(ad)">
                <img class="promo-strip__img" :src="ad.adImage" alt="" />
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
    </template>

    <van-dialog
      v-model="dialog.show"
      :showConfirmButton="false"
      class="cus-dialog"
    >
      <h3 class="title">温馨提示！</h3>
      <div class="msg">
        <p v-html="dialog.msg"></p>
        <ul
          v-if="
            dialog.ulMsgShow &&
              dialog.redeCodeStatus == 2 &&
              dialog.gcAttribute == 3
          "
        >
          <li>
            <span>充值商品：</span>
            <em>{{ dialog.goodsName }}</em>
          </li>
          <li>
            <span>充值账号：</span>
            <em>{{ dialog.account }}</em>
          </li>
          <li>
            <span>充值时间：</span>
            <em>{{ common.formatDate(dialog.rechargeTime, '{y}-{m}-{d}') }}</em>
          </li>
        </ul>
        <ul
          v-if="
            dialog.ulMsgShow &&
              dialog.redeCodeStatus === 2 &&
              dialog.gcAttribute != 3
          "
        >
          <li>
            <span>兑换商品：</span>
            <em>{{ dialog.goodsName }}</em>
          </li>
          <li>
            <span>手机号码：</span>
            <em>{{ dialog.account }}</em>
          </li>
          <li>
            <span>兑换时间：</span>
            <em>{{ common.formatDate(dialog.excTime, '{y}-{m}-{d}') }}</em>
          </li>
        </ul>
        <ul v-if="dialog.ulMsgShow && dialog.redeCodeStatus == 3">
          <li>
            <span>过期时间：</span>
            <em>{{ common.formatDate(dialog.expireTime, '{y}-{m}-{d}') }}</em>
          </li>
        </ul>
      </div>
      <div class="confirm" @click="dialogSure">确认</div>
    </van-dialog>

    <van-dialog
      v-model="promptVisible"
      :showConfirmButton="false"
      class="cus-dialog"
    >
      <h3 class="title">温馨提示！</h3>
      <div class="msg">
        <div v-show="goodsName" style="margin-bottom: 5px;">
          您兑换的商品是：{{ goodsName }}
        </div>
        <div>请确认充值账户，确认提交后不退不换</div>
      </div>
      <div class="operations">
        <div class="confirm" style="margin-right: 10px;" @click="submitConfirm">
          确认
        </div>
        <div class="confirm cancel" @click="promptVisible = false">取消</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant'
import {
  checkCode,
  getCaptcha,
  bindAccount,
  getPhoneVerifyCode,
  phoneRechargeVerify,
  getExchangePageDetail
} from '@/api'
import closeGrayImg from '@/assets/img/close_gray.png'

/** 表单文案默认；详情接口可在 page.fieldCopy 上按 key 覆盖（与 DEFAULT 结构一致） */
const DEFAULT_FIELD_COPY = {
  code: { label: '兑换码：', placeholder: '请输入兑换码' },
  account: { label: '充值账号：', placeholder: '请输入充值账号' },
  captcha: { label: '验证码：', placeholder: '请输入验证码' }
}

/**
 * 管理端「兑换码页面配置」直充类链接入口。
 * 路由示例：/#/customRecharge?view=123
 * - view：兑换页配置 id → getDetail/{view}
 * - 验证码默认图形；详情接口 captchaVerifyType=1 时为短信验证码（与 fieldCopy 等同源配置）
 */
export default {
  name: 'CustomRecharge',
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem
  },
  data() {
    return {
      bootLoading: true,
      bootError: '',
      page: {
        id: null,
        linkType: 2,
        linkName: '',
        bannerImage: '',
        exchangeRules: '',
        enableAd: 0,
        floatAd: 0,
        ads: [],
        /** 可选：{ code?, account?, captcha? } 各含 label / placeholder，与 DEFAULT_FIELD_COPY 同结构 */
        fieldCopy: {},
        /** 0 图形验证码（默认） 1 短信验证码，由详情接口下发 */
        captchaVerifyType: 0
      },
      form: {
        code: this.$route.query.code || undefined,
        phone: '',
        captcha: '',
        token: ''
      },
      time: 0,
      dialog: {
        show: false,
        msg: '',
        ulMsgShow: false
      },
      subBtnDisable: true,
      captchaImg: {
        captchaBase64: '',
        captchaKey: ''
      },
      promptVisible: false,
      goodsName: undefined,
      adClosed: false,
      closeGrayImg
    }
  },
  computed: {
    adList() {
      const ads = this.page.ads
      return Array.isArray(ads) ? ads.filter(a => a && a.adImage) : []
    },
    /** 是否走短信验证码（默认 false，仅配置 captchaVerifyType=1 时为 true） */
    useSmsCaptcha() {
      return Number(this.page.captchaVerifyType) === 1
    },
    bannerLayerStyle() {
      const url = this.page.bannerImage
      if (!url) {
        return {}
      }
      return {
        backgroundImage: `url("${url
          .replace(/\\/g, '/')
          .replace(/"/g, '%22')}")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center top',
        backgroundSize: '100%',
        backgroundColor: '#eef0f4'
      }
    },
    fieldCopy() {
      const fromApi = this.page.fieldCopy || {}
      const apiAcc = fromApi.account || {}
      const accountBase =
        this.useSmsCaptcha && !apiAcc.label && !apiAcc.placeholder
          ? { label: '手机号：', placeholder: '请输入手机号' }
          : DEFAULT_FIELD_COPY.account
      return {
        code: { ...DEFAULT_FIELD_COPY.code, ...(fromApi.code || {}) },
        account: { ...accountBase, ...apiAcc },
        captcha: {
          ...DEFAULT_FIELD_COPY.captcha,
          ...(fromApi.captcha || {})
        }
      }
    },
    rules() {
      const accountMsg = this.fieldCopy.account.placeholder
      const phoneVal = val => {
        if (this.useSmsCaptcha) {
          return /^1[3456789]\d{9}$/.test(val)
        }
        return !!(val && String(val).trim())
      }
      return {
        code: [
          {
            required: true,
            message: this.fieldCopy.code.placeholder
          }
        ],
        phone: [
          {
            required: true,
            validator: phoneVal,
            message: this.useSmsCaptcha ? '请输入正确的手机号' : accountMsg
          }
        ],
        captcha: [
          {
            required: true,
            message: this.fieldCopy.captcha.placeholder
          }
        ]
      }
    }
  },
  async mounted() {
    await this.loadPageConfig()
    if (this.bootError) {
      return
    }
    if (this.$route.query.code) {
      this.CheckCode()
    }
    if (!this.useSmsCaptcha) {
      this.getImgCode()
    }
    document.title = this.page.linkName || '商品直充'
  },
  methods: {
    async loadPageConfig() {
      const pageId = this.$route.query.view
      if (pageId == null || pageId === '') {
        this.bootLoading = false
        this.bootError = '链接缺少页面参数 view，无法加载配置'
        return
      }
      this.bootLoading = true
      this.bootError = ''
      try {
        const res = await getExchangePageDetail(pageId)
        if (res.code === 0 && res.data) {
          const d = res.data
          if (d.linkType != null && Number(d.linkType) !== 2) {
            this.bootError = '当前页面配置不是直充兑换类型'
            this.bootLoading = false
            return
          }
          this.page = {
            id: d.id,
            linkType: d.linkType != null ? Number(d.linkType) : 2,
            linkName: d.linkName || '',
            bannerImage: d.bannerImage || '',
            exchangeRules: d.exchangeRules || '',
            enableAd: d.enableAd != null ? Number(d.enableAd) : 0,
            floatAd: d.floatAd != null ? Number(d.floatAd) : 0,
            ads: Array.isArray(d.ads) ? d.ads : [],
            fieldCopy:
              d.fieldCopy && typeof d.fieldCopy === 'object' ? d.fieldCopy : {},
            captchaVerifyType:
              d.captchaVerifyType != null ? Number(d.captchaVerifyType) : 0
          }
        } else {
          this.bootError = res.message || '页面配置加载失败'
        }
      } catch (e) {
        this.bootError = '页面配置加载失败'
      } finally {
        this.bootLoading = false
      }
    },
    initForm() {
      this.form.phone = ''
      this.form.token = ''
      this.form.captcha = ''
    },
    CheckCode() {
      this.subBtnDisable = true
      const obj = {
        code: this.form.code,
        redeemCodePageType: this.useSmsCaptcha ? 14 : 0
      }
      checkCode(obj).then(res => {
        if (res.code == 0) {
          const data = res.data
          this.goodsName = data.goodsName
          if (data.routeFlag == 1) {
            this.form.token = data.token
            this.subBtnDisable = false
          } else if (data.routeFlag == 2) {
            this.initForm()
            this.dialog.msg = res.message
            for (const k in data) {
              this.dialog[k] = data[k]
            }
            this.dialog.show = true
            this.dialog.ulMsgShow = true
          } else {
            this.initForm()
            this.dialog.msg = '兑换类型不匹配，无法兑换！'
            this.dialog.show = true
          }
        } else {
          this.initForm()
          this.dialog.show = true
          if (res.data && res.data.checkRedeemCodeErrorCode) {
            switch (res.data.checkRedeemCodeErrorCode.code) {
              case -1:
                this.dialog.msg = '兑换码不存在'
                break
              case 1:
                this.dialog.msg = '该兑换码在兑换中'
                break
              case 2:
                this.dialog.msg = '该兑换码正在售后中，无法兑换！'
                break
              case 3:
                this.dialog.msg = '该兑换码已退款退券，无法兑换！'
                break
              case 4:
                this.dialog.msg = '该兑换码已冻结，无法兑换！'
                break
              case 5:
                this.dialog.msg = '该兑换码已使用'
                break
              case 6:
                this.dialog.msg = '兑换时间已过期'
                break
              case 7:
                this.dialog.msg = `兑换时间未开始，有效兑换时间：<br>${this.common.formatDate(
                  res.data.effectiveStartTime,
                  '{y}-{m}-{d}'
                )}~${this.common.formatDate(
                  res.data.effectiveEndTime,
                  '{y}-{m}-{d}'
                )}`
                break
              case 8:
                this.dialog.msg = '兑换类型不匹配'
                break
              case 9:
                this.dialog.msg = '兑换页面类型不匹配'
                break
              case 10:
                this.dialog.msg = '兑换手机号码信息不存在'
                break
              case 11:
                this.dialog.msg = '此兑换码已激活'
                break
              default:
                this.dialog.msg = res.message
                break
            }
          } else {
            this.dialog.msg = res.message
          }
        }
      })
    },
    redeemChange() {
      if (this.form.code) {
        this.CheckCode()
      }
    },
    submit() {
      if (!this.subBtnDisable) {
        this.promptVisible = true
      }
    },
    submitConfirm() {
      this.promptVisible = false
      this.$refs.form.submit()
    },
    subSuccess() {
      if (this.useSmsCaptcha) {
        this.phoneRecharge()
        return
      }
      const obj = {
        account: this.form.phone.trim(),
        captcha: this.form.captcha.trim(),
        token: this.form.token,
        captchaKey: this.captchaImg.captchaKey
      }
      bindAccount(obj).then(res => {
        if (res.code == 0) {
          this.dialog.msg = res.message
          this.dialog.show = true
        } else {
          this.dialog.msg = res.message
          this.dialog.show = true
        }
        this.getImgCode()
      })
    },
    getImgCode() {
      getCaptcha({}).then(res => {
        if (res.code == 0) {
          const { captchaBase64, captchaKey } = res.data
          this.captchaImg = {
            captchaKey,
            captchaBase64: `data:image/png;base64,${captchaBase64}`
          }
        }
      })
    },
    async getSmsCode() {
      const form = this.form
      if (this.subBtnDisable) {
        return
      }
      if (!/^1[3456789]\d{9}$/.test(form.phone)) {
        this.$toast.fail({
          message: '请输入正确的手机号码'
        })
        return
      }
      const { code, message } = await getPhoneVerifyCode({
        phone: form.phone.trim(),
        redeCodeNo: form.code.trim()
      })
      if (code === 0) {
        this.time = 60000
      } else {
        this.time = 0
        this.$toast.fail({
          message
        })
      }
    },
    async phoneRecharge() {
      const { code, message } = await phoneRechargeVerify({
        ...this.form,
        redeCodeNo: this.form.code.trim()
      })
      if (code === 0) {
        this.dialog.msg = message
        this.dialog.show = true
      } else {
        this.$toast.fail({ message })
      }
    },
    dialogSure() {
      this.dialog.show = false
      setTimeout(() => {
        this.dialog.ulMsgShow = false
      }, 200)
    },
    closeAd() {
      this.adClosed = true
    },
    onAdClick(ad) {
      if (!ad) {
        return
      }
      if (ad.jumpType === 1 && ad.h5Url) {
        window.location.href = ad.h5Url
      } else if (ad.jumpType === 2) {
        // 配置了明文 Scheme 的小程序才可以跳转
        // 开发者无需调用平台接口，在「MP平台 - 左下角账号 - 账号设置 - 基本设置 - 隐私与安全 - 
        // 明文Scheme拉起此小程序」声明后，可自行根据如下格式拼接appid和path等参数，作为明文 URL Scheme 链接。
        const path = `weixin://dl/business/?appid=${ad.appId}&path=${ad.jumpPath}`
        window.location.href = path
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/style/comCouRecStyle.less';

.custom-recharge-page {
  min-height: 100vh;
  background: #eef0f4;
  padding-bottom: env(safe-area-inset-bottom);
  --dock-promo-offset: 0px;
}
.custom-recharge-page.has-dock-promo {
  --dock-promo-offset: calc(170px + 24px + env(safe-area-inset-bottom));
}

.page-boot {
  padding: 80px 30px;
  text-align: center;
  font-size: 28px;
  color: #7a7a7a;
}
.page-boot--err {
  color: #ee0a24;
}

.custom-recharge-layer {
  min-height: 100vh;
  box-sizing: border-box;
  padding-bottom: var(--dock-promo-offset, 0px);
}

.rule-html {
  color: #7f7f7f;
  font-size: 26px;
  line-height: 1.8;
  word-break: break-word;
}
.rule-html /deep/ img {
  max-width: 100%;
  height: auto;
}
.rule-empty {
  color: #b1bac9;
  font-size: 26px;
}

.promo-strip {
  position: relative;
  max-width: 750px;
  box-sizing: border-box;
}
.promo-strip__close {
  position: absolute;
  top: -50px;
  right: 10px;
  z-index: 101;
  width: 50px;
  height: 50px;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
}
.promo-strip__close-icon {
  width: 28px;
  height: 28px;
  display: block;
  pointer-events: none;
}
.promo-strip--dock {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
  z-index: 100;
  box-sizing: border-box;
}
.promo-strip__slide {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.promo-strip__img {
  width: 100%;
  max-width: 750px;
  height: 170px;
  object-fit: cover;
  display: block;
}

.beian {
  display: block;
  text-align: center;
  padding: 20px 0 40px;
}

.operations {
  display: flex;
  .cancel {
    background-color: #999;
  }
}
.smsCode {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70px;
  background: #4086ff;
  width: 153px;
  text-align: center;
  border-top-right-radius: 35px;
  border-bottom-right-radius: 35px;
  color: #fff;
  &.is-disable {
    background: #dadada;
    cursor: not-allowed;
  }
  .cdown {
    color: #fff;
  }
}
</style>
